/**
 *
 * Asynchronously loads the component for Header
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
